
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},
})
export default class InvalidUnpaid extends Vue {
  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign;
  }
}
